<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    style="enable-background:new 0 0 512 512"
    xml:space="preserve"
    stroke="currentcolor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class=""
  ><g>
    <g xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M448.801,271H497c8.284,0,15-6.716,15-15V111.4c0-8.284-6.716-15-15-15H367.4V63.2c0-34.849-28.352-63.2-63.2-63.2    S241,28.352,241,63.2v33.2H111.4c-8.284,0-15,6.716-15,15V241H63.2C28.352,241,0,269.352,0,304.2s28.352,63.2,63.2,63.2h33.2V497    c0,8.284,6.716,15,15,15H256c8.284,0,15-6.716,15-15v-48.2c0-18.307,14.894-33.2,33.2-33.2c18.306,0,33.2,14.894,33.2,33.2V497    c0,8.284,6.716,15,15,15H497c8.284,0,15-6.716,15-15V352.4c0-8.284-6.716-15-15-15h-48.199c-18.308,0-33.201-14.894-33.201-33.2    C415.6,285.894,430.493,271,448.801,271z M448.801,367.4H482V482H367.4v-33.2c0-34.849-28.352-63.2-63.2-63.2    S241,413.951,241,448.8V482H126.4V352.4c0-8.284-6.716-15-15-15H63.2c-18.307,0-33.2-14.894-33.2-33.2    c0-18.306,14.894-33.2,33.2-33.2h48.2c8.284,0,15-6.716,15-15V126.4H256c8.284,0,15-6.716,15-15V63.2    c0-18.307,14.894-33.2,33.2-33.2c18.306,0,33.2,14.894,33.2,33.2v48.2c0,8.284,6.716,15,15,15H482V241h-33.199    c-34.85,0-63.201,28.352-63.201,63.2S413.951,367.4,448.801,367.4z"
          :fill="color"
          data-original="#000000"
          stroke-width="2"
          class=""
        />
      </g>
    </g>
  </g>
  </svg>
</template>

<script>
export default {
  name: 'PuzzleIcon',
  props: {
    size: {
      type: [String, Number],
      default: '21',
    },
  },
  computed: {
    color() {
      return this.isDark ? '#b4b7bd' : 'currentColor'
    },
  },
}
</script>
